import { ProMailMigrationMailboxStatus } from '../mail_migration';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PRO_MAIL_MIGRATION_MAILBOX_STATUS = 'PRO_MAIL_MIGRATION_MAILBOX_STATUS_';

export const ProMailMigrationMailboxStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_MAILBOX_STATUS}${ProMailMigrationMailboxStatus.PENDING}`]: 'En attente',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_MAILBOX_STATUS}${ProMailMigrationMailboxStatus.SYNCING}`]: 'Copie en cours',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_MAILBOX_STATUS}${ProMailMigrationMailboxStatus.SYNCED}`]: 'Copiée',
    [`${TRANSLATE_KEY_PRO_MAIL_MIGRATION_MAILBOX_STATUS}${ProMailMigrationMailboxStatus.ERROR}`]: 'Erreur',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  ProMailMigrationMailboxStatus,
  ProMailMigrationMailboxStatusTranslation,
  TRANSLATE_KEY_PRO_MAIL_MIGRATION_MAILBOX_STATUS,
  true,
);
